//////////////////////////////////////////////////////////////////////
// Configuration for listing collections (carousels of listings).   //
//////////////////////////////////////////////////////////////////////

import { COLLECTION_SOURCES } from '../util/listingCollections';

/**
 * A collection describes one carousel of listings.
 *
 * - id:               Unique key. Used as the Redux key and as the PageBuilder sectionId,
 *                     so an operator can place the collection from Console by adding a
 *                     section with the same sectionId (otherwise it renders above the footer).
 * - source:           'query'   -> listings come from the params below
 *                     'author'  -> other listings from the author of the current listing
 *                     'similar' -> listings sharing the deepest category (or listing type)
 *                     'tag'     -> listings tagged with metadata.collections
 * - tagSlug:          Required when source is 'tag'. The metadata.collections value to match.
 * - titleKey:         Translation key for the heading.
 * - fallbackTitleKey: Used instead of titleKey when a title value is missing (e.g. no author name).
 * - params:           Extra Marketplace API listing query params.
 * - limit:            Max number of listings shown.
 */

// Collections shown at the bottom of the listing page.
export const listingPageCollections = [
  {
    id: 'similarListings',
    source: COLLECTION_SOURCES.SIMILAR,
    titleKey: 'ListingCollection.similarListings',
    limit: 8,
  },
  {
    id: 'moreFromSeller',
    source: COLLECTION_SOURCES.AUTHOR,
    titleKey: 'ListingCollection.moreFromSeller',
    fallbackTitleKey: 'ListingCollection.moreFromSellerFallback',
    limit: 8,
  },
];

// Collections shown on the landing page.
//
// A TAG collection is filled by tagging listings in Console with
// metadata.collections = ["<tagSlug>"]. That key is deliberately separate from
// metadata.badges: a curated listing shows no pill, so curation never competes with
// Ausgezeichnet / Beliebt / Neu for the single badge slot on a card.
//
// One-time setup: metadata.collections must be indexed as multi-enum before the query
// works. Until then the query fails and the section hides itself, so this is safe to
// ship ahead of the Console work.
//
// Adding another curated row is this config entry plus one translation key.
export const landingPageCollections = [
  {
    id: 'editorsPicks',
    source: COLLECTION_SOURCES.TAG,
    tagSlug: 'editorsPicks',
    titleKey: 'ListingCollection.editorsPicks',
    limit: 8,
  },
];

// Feeds on the React home page (containers/HomePage). The curated wishlist rows are
// resolved at load time from HOME_WISHLIST_SLUGS, so they are not listed here.
//
// `title` is a literal because the home page copy is German-only, like the landing pages.
export const homePageCollections = [
  {
    id: 'home-new',
    source: COLLECTION_SOURCES.QUERY,
    title: 'Neu auf Toastably',
    params: { sort: 'createdAt' },
    limit: 8,
    footerLink: { link: { name: 'SearchPage' }, label: 'Alle ansehen' },
  },
];
